// CommitChart.js
import { Doughnut } from 'vue-chartjs'
import _ from 'lodash'
import ColorsMixin from '../mixins/ChartColorsMixin';
import { EventBus } from '../srores/eventBus.js';


let vm = {};
let i = 0;

var options = {
    responsive: true,
    cutoutPercentage: 25,
    rotation: 1.3 * Math.PI,
    animation: {
        animateScale: true,
        animateRotate: false
    },
    tooltips: {
        enabled: false
    },
    hover: {mode: null}
};

export default Doughnut.extend({

    mixins: [ ColorsMixin ],

    props: ['results'],

    data () {
        return {
            dat: 'aaa'
        }
    },


    mounted () {
        var vm = this;

        // Overwriting base render method with actual data.
        setTimeout(function(){
            vm.renderChart(vm.chartData, options);
        }, 1500);

        EventBus.$on('rerender', impacts => {
            console.log('rerendering', impacts);
            vm._chart.update();
        });
    },

    computed: {
        chartData()  {
            return {
                datasets: [
                    {
                        backgroundColor: this.colorsArray.c4,
                        data: [1, 1, 1, 1, 1]
                    },
                    {
                        backgroundColor: this.colorsArray.c3,
                        data: [1, 1, 1, 1, 1]
                    },
                    {
                        backgroundColor: this.colorsArray.c2,
                        data: [1, 1, 1, 1, 1]
                    },
                    {
                        backgroundColor: this.colorsArray.c1,
                        data: [1, 1, 1, 1, 1]
                    },
                    {
                        backgroundColor: this.colorsArray.c0,
                        data: [1, 1, 1, 1, 1]
                    }
                ]
            }
        },

        colorsArray() {
            let vm = this;
            let output = {};
            let i = 0;

            for (i = 0; i < 5; i++) {

                vm.i = i;

                output['c' + vm.i] = [];

                _.forEach(vm.results, function(item){

                    let color = '';

                    if (item >= ( vm.i  + 1)) {
                        color = vm.activeColors[item - 1];
                    } else {
                        color = vm.pasiveColors[vm.i];
                    }
                    /*
                    if (item >= ( vm.i  + 1)) {
                        color = vm.activeColors[vm.i];
                    } else {
                        color = vm.pasiveColors[vm.i];
                    }
                    */

                    output['c' + vm.i].push(color);
                });
            }

            return output;
        }
    }
})